import $ from 'jquery'

$('[sider-toggle]').click(() => {
  if($('.sider-bar').hasClass('show')) {
    $('.sider-bar').removeClass('show')
  } else {
    $('.sider-bar').addClass('show')
  }
})